/**
 * Utility functions for Reviews module
 */

import { QUALITY_RATING_NAME } from './constants'

import type { RatingBreakdown } from '../types'

/**
 * Processes reviews to ensure they have valid ratings_breakdown data
 * Adds default rating if ratings_breakdown is empty
 */
export function processReviews<
  T extends { average_rating?: number; ratings_breakdown?: RatingBreakdown[] },
>(reviews: T[]): T[] {
  return reviews.map((review) => ({
    ...review,
    average_rating: review.average_rating || 100,
    ratings_breakdown:
      review.ratings_breakdown && review.ratings_breakdown.length > 0
        ? review.ratings_breakdown
        : [{ name: QUALITY_RATING_NAME, value: '5' }],
  }))
}
